import * as api from "../constants/api";
import * as axiosUtils from "../utils/axiosUtils";

export const actionTypeSkiftlogger = "SKIFTLOGGER";

export const getSkiftlogger = (skiftloggerFormState) => {
  const {
    selectedTjenestenummer,
    fraDatoValidationErrorText,
    tilDatoValidationErrorText,
    ...params
  } = skiftloggerFormState;

  return axiosUtils.GetAllWithParamsSerializer(
    api.GET_SKIFTLOGGER_URL,
    params,
    actionTypeSkiftlogger,
    "skiftlogger",
  );
};
